import React, {Component} from "react"
import {connect} from "react-redux"
import {injectIntl} from 'react-intl'
import {Button, Modal} from "react-bootstrap"
import IBoxRow from "../../../components/IBoxRow"
import {Input} from "formsy-react-components"
import fetch from "isomorphic-fetch"
import {PATH_USER_SEARCH} from "../../../constants"
import Form from "../../../components/form/Form"
import config from "../../../config"
import {confirm} from "../../../util/AlertUtil"

function mapStateToProps(state, ownProps) {
  const user = state.user
  return {
    user
  }
}

const mapDispatchToProps = {}

class EmailCheckingModal extends Component {

  constructor() {
    super()
    this.state = {
      disabled: true,
      exists: false,
      checked: false
    }

  }

  checkEmail(emailAddress) {

    const _this = this
    const format = _this.props.intl.formatMessage

    _this.setState({
      checked: false,
      exists: false
    })

    const {api_server_host} = config

    const token = this.props.user.access_token
    const type = this.props.user.token_type

    fetch(`${api_server_host}${PATH_USER_SEARCH}?query=${emailAddress}&exactMatch=true`
      , {
        headers: {
          Authorization: `${type} ${token}`
        }
      })
      .then((response) => {
        return response.json();
      }).then((json) => {

      const exists = json && json.length === 1

      _this.setState({
        checked: true,
        emailAddress,
        exists
      })

      if(exists){
        const userId = json[0].id
        confirm(
          format({id:'confirm.title.add.user'}),
          format({id:'confirm.text.add.user'}, {emailAddress}),
          format({id: 'invite.user'}),
          ()=>{
            if (this.props.onUserExists)
              this.props.onUserExists(emailAddress, userId)
          }
        )
      }else{
        confirm(
          format({id:'confirm.title.existing.user'}),
          format({id:'confirm.text.existing.user'}, {emailAddress}),
          format({id: 'add.user'}),
          ()=>{
            if (this.props.onNewUser)
              this.props.onNewUser(emailAddress)
          },
          'success'
          )

      }

      this.props.onHide()

    });
  }

  enableSubmitButton = () => {
    this.setState({
      disabled: false
    });
  }

  disableSubmitButton = () => {
    this.setState({
      disabled: true
    });
  }

  render() {


    const format = this.props.intl.formatMessage


    return (
      <Modal bsSize="md"
             onEntered={() => {
               this.setState({
                 disabled: true,
                 checked: false,
                 exists: false
               })
             }}
             show={this.props.show} onHide={this.props.onHide}>

        <Modal.Header closeButton>
          <h2>{format({id: 'add.user'})}</h2>
        </Modal.Header>

        <Modal.Body className="gray-bg" style={{height: 200}}>

          <IBoxRow>
            <div className="row">
              <div className="col-xs-10">
                <p>{format({id:'email.checking.desc.1'})}</p>
                <p>{format({id:'email.checking.desc.2'})}</p>

                <Form
                  onSubmit={(data)=>{this.checkEmail(data.emailAddress)}}
                  onValid={() => {
                    this.enableSubmitButton()
                  }}
                  onInvalid={() => {
                    this.disableSubmitButton()
                  }}
                  onRef={(form)=>{this.form = form}}
                  >


                  <div className="form-group">
                    <Input
                      name="emailAddress"
                      label={format({id: 'input.label.email'})}
                      type="email"
                      validations="isEmail"
                      validationErrors={{
                        isEmail: format({id: 'input.error.email'})
                      }}
                      required={true}
                      readOnly={this.state.checked}
                    />


                  </div>
                </Form>
              </div>

            </div>


          </IBoxRow>

        </Modal.Body>

        <Modal.Footer>

          <Button onClick={this.props.onHide}>
            {format({id: 'cancel'})}
          </Button>
          <div className={`btn btn-primary ${this.state.disabled ? 'disabled' : ''}`} onClick={() => {

            if(this.state.disabled) return

            if(!this.state.checked)
              this.form.submit()

          }}>
            {this.state.checked ?
              !this.state.exists ?
                format({id: 'add.user'})
                :
                format({id: 'invite.user'})
              :
              format({id: 'check'})}
          </div>

        </Modal.Footer>
      </Modal>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(EmailCheckingModal))



// WEBPACK FOOTER //
// ./src/routes/enterprise/components/EmailCheckingModal.js